module.exports = __webpack_public_path__ + "img/screen-app-settings.ef1684ed.jpg";